module.exports = __webpack_public_path__ + "img/556.52c26933.jpg";